// Cart
export const UPDATE_CART_ITEM = "UPDATE_CART_ITEM";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const CLEAR_CART_ITEMS = "CLEAR_CART_ITEMS";

// Flash notification 
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const EDIT_NOTIFICATION = "EDIT_NOTIFICATION";

// Pizza list
export const PIZZA_LIST_LOADING = "PIZZA_LIST_LOADING";
export const PIZZA_LIST_SUCCESS = "PIZZA_LIST_SUCCESS";
export const PIZZA_LIST_FAILED = "PIZZA_LIST_FAILED";
export const LAZY_PIZZA_LIST_START = "LAZY_PIZZA_LIST_START";
export const LAZY_PIZZA_LIST_SUCCESS = "LAZY_PIZZA_LIST_SUCCESS";

// Topping list
export const PIZZA_TOPPINGS_LOADING = "PIZZA_TOPPINGS_LOADING";
export const PIZZA_TOPPINGS_SUCCESS = "PIZZA_TOPPINGS_SUCCESS";
export const PIZZA_TOPPINGS_FAILED = "PIZZA_TOPPINGS_FAILED";

// Orders
export const ORDERS_LOADING = "ORDERS_LOADING";
export const ORDERS_SUCCESS = "ORDERS_SUCCESS";
export const ORDERS_FAILED = "ORDERS_FAILED";

// Auth
export const AUTH_START = 'AUTH_START ';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
